import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import translations from "@/data/translations";
import { Cookie } from "lucide-react";

const CookieBanner = () => {
  const { lang } = useLang();
  const t = translations[lang].cookies;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("okontainers_cookies");
    if (consent) return;
    const timer = setTimeout(() => setVisible(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  const handle = (choice) => {
    try {
      localStorage.setItem("okontainers_cookies", choice);
    } catch (e) {
      // localStorage not available
    }
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4 }}
          data-testid="cookie-banner"
          className="fixed bottom-0 left-0 right-0 z-[55] md:bottom-4 md:left-4 md:right-auto md:max-w-md"
        >
          <div className="bg-navy border border-white/10 rounded-none md:rounded-2xl p-5 md:p-6 shadow-2xl shadow-black/30 backdrop-blur-lg">
            <div className="flex items-start gap-3 mb-4">
              <Cookie size={20} className="text-electric-light shrink-0 mt-0.5" />
              <p className="text-slate-300 text-sm leading-relaxed font-body">{t.text}</p>
            </div>
            <div className="flex gap-3">
              <button
                data-testid="cookie-accept"
                onClick={() => handle("all")}
                className="flex-1 bg-electric text-white font-semibold text-sm py-2.5 rounded-full hover:bg-electric-hover transition-all"
              >
                {t.accept}
              </button>
              <button
                data-testid="cookie-reject"
                onClick={() => handle("essential")}
                className="flex-1 bg-white/10 text-white font-medium text-sm py-2.5 rounded-full hover:bg-white/20 transition-all border border-white/10"
              >
                {t.reject}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
